if (!customElements.get('km-home-hero')) {
  customElements.define('km-home-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.dots = [...this.querySelectorAll('[data-hero-go]')];
      this.status = this.querySelector('[data-hero-status]');
      this.index = 0;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.inView = true;
      this.querySelector('.km-hero-controls').hidden = false;
      this.dots.forEach((button, index) => button.addEventListener('click', () => {
        this.show(index, true);
        this.schedule();
      }, options));
      this.addEventListener('mouseenter', () => this.schedule(), options);
      this.addEventListener('mouseleave', () => this.schedule(), options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.schedule(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      });
      this.observer.observe(this);
      this.show(0);
      this.schedule();
    }
    show(index, announce = false) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        this.dots[i].setAttribute('aria-current', String(active));
      });
      if (announce) this.status.textContent = `Slide ${index + 1} of ${this.slides.length}`;
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.paused || !this.inView || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => {
        this.show((this.index + 1) % this.slides.length);
        this.schedule();
      }, 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
